<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Biên bản kiểm tra</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <AbsentFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>

    <v-card v-else outlined class="elevation-0">
      <AbsentTable :query="query" v-if="query.subject" />
      <AbsentAllTable :query="query" :subjects="subjects" v-else />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import AbsentFilter from '@/modules/exam/AbsentFilter.vue'
import AbsentTable from '@/modules/exam/AbsentTable.vue'
import AbsentAllTable from '../../modules/exam/AbsentAllTable.vue'

export default {
  components: {
    StudentBlankView,
    AbsentFilter,
    AbsentTable,
    AbsentAllTable
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subjects: [],
      rooms: [],
      query: {},
      type: '',
      grade: ''
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, subjects, rooms, type, grade) {
      this.action.state = 'filtered'
      this.query = params
      this.subjects = subjects
      this.rooms = rooms
      this.type = type
      this.grade = grade
    }
  }
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
